<template>
  <div>
    <div class=" w-full">
      <p class=" font-semibold mb-4 inline-block">
        Annual Gross Pay
      </p>
    </div>
    <div class="col-span-12">
      <div class="text-base flex text-jet">
        <p>Payroll Status:</p>
        <p
          class="ml-4 "
          :class="
            payrollStatus === 'active' ? ' text-mediumSeaGreen' : 'text-flame'
          "
        >
          {{ payrollStatus ? toTitleCase(payrollStatus) : "Inactive" }}
        </p>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-3 text-darkPurple" style="margin-top:1.125rem">
      <div class="col-span-3">
        <div class="text-sm mb-1 text-jet">
          Annual Gross Pay
        </div>
        <div class="disabled">
          {{ annualGross }}
        </div>
      </div>   
      <div class="col-span-3" v-if="!isBasic && payType === 'salaried' && compensationData.compensationMode === 'rangeBased'">
        <div class="text-sm mb-1 text-jet">
          Pay Band
        </div>
        <div class="disabled">
          {{ compensationData.payGradeId || "Autoloaded" }}
        </div>
      </div>
      <div class="col-span-3" v-if="!isBasic && payType === 'salaried' && compensationData.compensationMode === 'rangeBased'">
        <div class="text-sm mb-1 text-jet">
          Range Penetration
        </div>
        <div class="disabled">
          {{ compensationData.rangePenetration || "Autoloaded" }}
        </div>
      </div>
      <div class="col-span-3" v-if="!isBasic && payType === 'salaried' && compensationData.compensationMode === 'rangeBased'">
        <div class="text-sm mb-1 text-jet">
           Compa-Ratio
        </div>
        <div class="disabled">
          {{ compensationData.compaRatio || "Autoloaded" }}
        </div>
      </div>
      <div class="col-span-3" v-if="!isBasic && compensationData.compensationMode === 'scaleBased'">
        <div class="text-sm mb-1 text-jet">
          Pay Scale ID
        </div>
        <div class="disabled">
          {{ compensationData.payScaleId || "Autoloaded" }}
        </div>
      </div>
      <div class="col-span-3" v-if="!isBasic && compensationData.compensationMode === 'scaleBased'">
        <div class="text-sm mb-1 text-jet">
          Pay Scale
        </div>
        <div class="disabled">
          {{ compensationData.payScaleAmount || "Autoloaded" }}
        </div>
      </div>
      <div class="col-span-3" v-if="!isBasic">
        <div class="text-sm mb-1 text-jet">
          Effective Tax Rate (%)
        </div>
        <div class="disabled">
          {{ compensationData ? compensationData.effectiveTaxRate : "---" }}
        </div>
      </div>
      <div class="col-span-3" v-if="isBasic || (!isBasic && employmentType !== 'Independent Contractor')">
        <div class="text-sm mb-1 text-jet">
          Expected PAYE Deduction (₦)
        </div>
        <div class="disabled">
          {{
            !!Number(String(annualGross ?? '').trim().replace(/,/g,'')) === false ?
            "Autoloaded (monthly)" : !!Number(String(annualGross ?? '').trim().replace(/,/g,'')) === true && !expectedPayePay ?
            0 : expectedPayePay.toLocaleString("en-US")
          }}
        </div>
      </div>
     <div class="col-span-3" v-if="isBasic || (!isBasic && employmentType !== 'Independent Contractor')">
        <div class="text-sm mb-1 text-jet">
          Expected PENSION Deduction(₦)
        </div>
        <div class="disabled">
          {{ 
            !!Number(String(annualGross ?? '').trim().replace(/,/g,'')) === false ?
            "Autoloaded (monthly)" : !!Number(String(annualGross ?? '').trim().replace(/,/g,'')) === true && !expectedPensionPay ?
            0 : expectedPensionPay.toLocaleString("en-US")
          }}
        </div>
      </div>
     <div class="col-span-3" v-if="isBasic || (!isBasic && employmentType !== 'Independent Contractor')">
        <div class="text-sm mb-1 text-jet">
          Calculated NHF Deduction
        </div>
        <div class="disabled">
          {{
            !!Number(String(annualGross ?? '').trim().replace(/,/g,'')) === false ?
            "Autoloaded (monthly)" : !!Number(String(annualGross ?? '').trim().replace(/,/g,'')) === true && !expectedNhfPay ?
            0 : expectedNhfPay.toLocaleString("en-US")
          }}
        </div>
      </div>
      <div class="col-span-3" v-if="isBasic || (!isBasic && employmentType !== 'Independent Contractor')">
        <div class="text-sm mb-1 text-jet">
          Calculated NHIS Deduction
        </div>
        <div class="disabled">
          {{
            !!Number(String(annualGross ?? '').trim().replace(/,/g,'')) === false ?
            "Autoloaded (monthly)" : !!Number(String(annualGross ?? '').trim().replace(/,/g,'')) === true && !expectedNhisPay ?
            0 : expectedNhisPay.toLocaleString("en-US")
          }}
        </div>
      </div>
      <div class="col-span-3" v-if="!isBasic && employmentType === 'Independent Contractor'">
        <div class="text-sm mb-1 text-jet">
          Calculated WHT Deduction(₦)
        </div>
        <div class="disabled">
          {{
            !!Number(String(annualGross ?? '').trim().replace(/,/g,'')) === false ?
            "Autoloaded (monthly)" : !!Number(String(annualGross ?? '').trim().replace(/,/g,'')) === true && !expectedWhtAmount ?
            0 : expectedWhtAmount.toLocaleString("en-US")
          }}
        </div>
      </div>
      <div class="col-span-3">
        <div class="text-sm mb-1 text-jet">
          Expected Net Income (₦)
        </div>
        <div class="disabled">
          {{
            !!Number(String(annualGross ?? '').trim().replace(/,/g,'')) === false ?
            "Autoloaded (monthly)" : !!Number(String(annualGross ?? '').trim().replace(/,/g,'')) === true && !expectedNetPay ?
            0 : expectedNetPay.toLocaleString("en-US")
          }}
        </div>
      </div>
    </div>
    <!-- <table class=" w-full mt-4">
      <thead>
        <tr>
          <th>#</th>
          <th
            class=" uppercase"
            v-for="(header, index) in headers"
            :key="index"
          >
            <p>{{ header.title }}</p>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(data, i) in grossEarningsData"
          :key="i"
          class="tableBody text-sm"
          style="height: 48px; "
        >
          <td>
            {{ i + 1 }}
          </td>
          <td>
            {{ data.payItem.name }}
          </td>
          <td>
            {{ Capitalize(data.payType) }}
          </td>
          <td>
            {{ data.rateType.label }}
          </td>
          <td>
            {{ data.rateValue }}
          </td>
          <td>
            {{ data.actualAmount ? convertToCurrency(data.actualAmount) : "-" }}
          </td>
        </tr>
        <tr class="h-7" />
        <tr
          style="height: 52px; border-spacing: 15px 0;"
          class="mt-4 bg-ghostWhite"
        >
          <td class="" />
          <td class="font-bold text-lg text-darkPurple ">
            Total
          </td>
          <td />
          <td />
          <td class="font-bold text-blueCrayola text-lg">
            {{ "%" }}
          </td>
          <td class="font-bold">
            {{ convertToCurrency(totalGrossEarning) }}
          </td>
        </tr>
      </tbody>
    </table> -->
    <accordion-pay-info-table v-if="!isBasic && employmentType !== 'Independent Contractor'"
      :gross-earnings-data="grossEarningsData"
      :total-amount="totalGrossAmount"
      :total-percent="totalPercent"
      :variable-table="variableData"
    />
    <ind-contractor-pay-info-table v-if="!isBasic && employmentType === 'Independent Contractor'"
      :gross-earnings-data="grossEarningsData"
      :total-amount="totalGrossAmount"
      :total-percent="totalPercent"
      :variable-table="variableData"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  components: {
    AccordionPayInfoTable: () =>
      import(
        "@/modules/Admin/EmployeeModule/EmployeeDirectory/EditEmployee/payInformation/annualGross/accordionPayInfoTable"
      ),
    IndContractorPayInfoTable: () =>
      import(
        "@/modules/Admin/EmployeeModule/EmployeeDirectory/EditEmployee/payInformation/annualGross/IndContractorPayInfoTable"
      )
  },
  props: {
    totalGross: {
      type: String,
      default: ""
    },
    totalGrossEarning: {
      type: Object,
      default: () => ({})
    },
    expectedNetPay: {
      type: Number,
      default: null
    },
    expectedNhfPay: {
      type: Number,
      default: null
    },
    expectedPayePay: {
      type: Number,
      default: null
    },
    expectedPensionPay: {
      type: Number,
      default: null
    },
    expectedNhisPay: {
      type: Number,
      default: null
    },
    expectedWhtAmount:{
      type: Number,
      default: null
    }
  },
  data() {
    return {
      payrollStatus: null,
      error: false,
      setSalary: "",
      annualGross: "",
      variableData: {},
      totalGrossAmount: 0,
      totalPercent: 0,
      grossEarningsData: [],
      headers: [
        { title: "pay item" },
        { title: "pay type" },
        { title: "rate type" },
        { title: "rate (%)" },
        { title: "amount(₦)" }
      ],
      compensationData: {
        compaRatio: null,
        grossPay: null,
        payGradeId: "",
        rangeMaximum: 0,
        rangeMidPoint: 0,
        rangeMinimum: 0,
        rangePenetration: 0,
        effectiveTaxRate: '0%',
        compensationMode: "",
        payScaleId: "",
        payScaleAmount: 0
      },
      payType: "salaried",
      employmentType: '',
    };
  },
  computed: {
    ...mapState({
      employeeDetails: state => state.employee.allEmployeeDetails
    }),
    isBasic() {
      return (
        this.$store.state.subscription &&
        this.$store.state.subscription.plan === "basic"
      );
    },
    totalRate() {
      const result = 7;
      return result;
    },
    totalAmount() {
      const result = "---";
      return result;
    }
  },
  watch: {
    annualGross(value) {
      let newValue = Number(value.split(",").join(""));
      const salary = this.employeeDetails.userDesignation;
      const lowerBand = Number(salary.lowerAnnualSalaryBand);
      const upperBand = Number(salary.upperAnnualSalaryBand);

      if (newValue > lowerBand && newValue < upperBand) {
        this.error = false;
      } else {
        this.error = true;
      }

      newValue = newValue.toString();
      return newValue.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  methods: {
    editAnnualGross() {
      this.annualGrossPay.isDisabled = false;
      this.annualGrossPay.isEdit = false;
    },
    async getEmployeeSalary() {
      const { data } = await this.$_getEmployeeSalaryBreakDown({
        id: this.$AuthUser.id
      });
      this.grossEarningsData = data.salaryBreakdown;
      this.totalGrossAmount = data.totalGrossAmount;
      this.totalPercent = data.totalGrossPercent;
      this.variableData = data.variableSalaryBreakdown;
    },
    async getEmployeeSalary() {
      const { data } = await this.$_getEmployeeSalaryBreakDown({
        id: this.$AuthUser.id
      });
      this.grossEarningsData = data.salaryBreakdown;
      this.totalGrossAmount = data.totalGrossAmount;
      this.totalPercent = data.totalGrossPercent;
      this.variableData = data.variableSalaryBreakdown;
    }
  },
  async mounted() {
    const { employmentType, grossPay, payrollStatus, compensation, payType } = await this.employeeDetails;
    this.employmentType = employmentType;
    this.annualGross = grossPay.toString();
    this.annualGross = this.annualGross
      .replace(/\D/g, "")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    this.payrollStatus = payrollStatus;
    this.payType = payType;
    this.compensationData = compensation;
    this.getEmployeeSalary();
  }
};
</script>

<style lang="scss" scoped>
.payInfo {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  padding: 10px 15px;
  max-height: 40px;
  width: 251px;
  &_fakeInput {
    background: #f7f7ff;
    border-color: #878e99;
  }
  &_disabled {
    background: #eeeeee;
    border: none;
    color: #878e99;
  }
  &_unallocated {
    padding: 12px 16px;
    background: #fff5f5;
    border-color: #ea3c53;
    max-height: 65px;
  }
}
</style>